<template>
  <div class="bluebackground fullheight" >
    <vue-scroll>
  <transition name="fade">
    <div class="bluebackground fullwidth fullheight centeredcontent">
      <transition name="fadeFirst" :mode="animationMode">
        <!-- Show Then Start Screen -->
        <div
            v-if="introStatus === 'Step-02-Menu'"
            key="1"
            class="fullwidth"
        >
          <v-container fluid>
            <v-row no-gutters justify="center">

              <v-col cols="12">
                <h1 id="headerTitle" class="mt-5" style="align-self: center">
                  Select your aircraft
                </h1>
              </v-col>

              <template>
                <v-col class="aircraftblock" v-for="aircraft in aircrafts" v-bind:key="aircraft.name" cols="12" md="6">
                  <v-card @click="startEngines(aircraft.config.name)"
                          class="aircraft-card" :ripple="false"
                  >
                    <v-img
                        :contain="true"
                        :alt="aircraft.selected"
                        :src="aircraft.getAsset('preview')"
                    />
                    <v-card-title
                        class="justify-center embossed"
                    >{{ aircraft.config.name }}
                    </v-card-title>
                  </v-card>
                </v-col>
              </template>

              <v-col cols="12">
                <div class="bottommargindesktop">&nbsp;</div>
              </v-col>
            </v-row>


          </v-container>
        </div>

        <div
            v-else-if="introStatus === 'Step-03-FadeOut'"
            class="fullwidth fullheight LoadingOverlay"
            key="3"
        />

      </transition>
    </div>
  </transition>
    </vue-scroll>
  </div>
</template>

<script>
import {aircraftConfig, aircrafts, settings} from "@/config";

export default {
  name: "home",

  data: function () {
    return {
      centerflex: true,
      introStatus: "Step-01-Logo",
      animationMode: "out-in",
      loadingPic: ""
    };
  },
  computed: {
    aircrafts() {
      return aircrafts;
    },
  },

  methods: {
    startEngines: function (aircraftName) {
      const config = aircraftConfig.find(aircraftName);
      this.loadingPic = config.getAsset('cockpit_loading');

      this.animationMode = ""; //we change the animation mode, so the Aircraft Pic and Start Screen blend in together
      this.introStatus = "Step-03-FadeOut"; //then we blend Start Menu into Aircraft Pic
      const routeToCockpit = ()=>{
        this.centerflex = false;
        this.$router.push({
          name: "cockpit",
          params: {aircraft: aircraftName}
        });
      }
      window.router = this.$router;
      window.routeToCockpit = routeToCockpit;
      //when the Transition to the Aircraft Pic is over, we route to the cockpit view
      setTimeout(routeToCockpit, 100);
    }
  },

  mounted: function () {
    //we do this setTimeOut to blend out the LAT Logo for 1 second in the beginning
    setTimeout(() => {
      this.introStatus = "Step-02-Menu";
    }, 1000);
  }
};
</script>

<style scoped lang="less">

.aircraft-card {
  transition: all 200ms ease-out;
  cursor: pointer;
  padding: 8px;
}

.aircraft-card:hover {
  box-shadow: 0 0 6px rgb(13, 71, 161) !important;
}

.aircraft-card:focus, .aircraft-card:active {
  box-shadow: 0 0 16px rgb(13, 71, 161) !important;
}

/* Small only */
@media screen and (max-width: 599px) {
  #headerTitle {
    font-size: medium;
    font-weight: normal;
  }

  #latLogo {
    transform: translateX(-20px);
  }

  .embossed {
    font-size: 20px;
  }

}

/* Medium only */
@media screen and (min-width: 600px) and (max-width: 1264px) {
  #headerTitle {
    font-size: x-large;
  }

  #latLogo {
    transform: translateX(-30px);
  }

  .embossed {
    font-size: 25px;

  }

  .aircraft-card .a320 {
    margin: 0 6em;
  }
}

/* Large only */
@media only screen and (min-width: 1264px) {
  #latLogo {
    transform: translateX(-50px);
  }

  .embossed {
    font-size: 30px;

  }
}


#headerTitle {
  font-family: Lufthansa Head Light;
  text-transform: uppercase;
  color: white;
  font-size: 28pt;
}

.bluebackground{
  background-color: #dbecff;
}

.centeredcontent{
  align-items: center;
  display: flex;
}

.bottommargindesktop{
  @media screen and (orientation:portrait) {
    /* nothing, centering is just fine */
  }
  @media screen and (orientation:landscape) {
    height: 200px /* add height, so all items get shifted to top (meaning like negative margin for the select-aircraft-title */
  }
}


/* Animation to next Page*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

/* Animation from Logo to Start Screen */
.fadeFirst-enter-active {
  transition: opacity 1s ease-in;
}

.fadeFirst-leave-active {
  transition: opacity 0.5s ease-out;
}

.fadeFirst-enter,
.fadeFirst-leave-to {
  opacity: 0;
}

.fullwidth {
  width: 100vw;
}
.fullheight {
  height: 100vh;
}

.aircraftblock {
  margin-top: 3%;
  padding-left: 4% !important;
  padding-right: 4% !important;
}

.embossed {
  text-shadow: -1px -1px 1px #fff, 1px 1px 1px #000;
  opacity: 0.3;
}

.v-card--link:before {
  background: none;
}

</style>
